import { Snackbar, Alert } from "@mui/material";

function SelectProjectPrompt({ open, onClose }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity="warning" variant="filled" sx={{ width: "100%" }}>
        Please select a project first
      </Alert>
    </Snackbar>
  );
}

export default SelectProjectPrompt;
